import { useTranslation } from "react-i18next"
import { Toaster as Sonner, toast } from "sonner"

const Toaster = ({
  className = "",
  toastOptions = {},
  ...props
}) => {
  const { t } = useTranslation()

  return (
    <Sonner
      position="top-center"
      closeButton
      visibleToasts={3}
      gap={10}
      duration={5000}
      offset={{ top: "var(--lp-toast-top)", left: 12, right: 12 }}
      mobileOffset={{ top: "var(--lp-toast-top)", left: 12, right: 12 }}
      {...props}
      className={`toaster lp-toaster ${className}`}
      toastOptions={{
        closeButtonAriaLabel: t("common.close"),
        ...toastOptions,
        classNames: {
          ...toastOptions.classNames,
          toast: `lp-toast ${toastOptions.classNames?.toast || ""}`,
        },
      }}
    />
  );
}

export { Toaster, toast }
